module.exports = __webpack_public_path__ + "img/filter-close.b04103a7.svg";